import React, { useState, useEffect } from "react";
import { renderToString } from 'react-dom/server';
import { TagCloud } from "@frank-mayer/react-tag-cloud";

const skillItems = (skill, index) => {
    const url = 'https://en.wikipedia.org/wiki/' + skill;
    return (
        <a href={url} target="_blank" rel="noreferrer" className={index % 2 ? `text-primary` : `text-secondary`}>{skill}</a>
    )
}

const SkillCloud = ({ skills }) => {
    const [options, setOptions] = useState({
        maxSpeed: 'fast',
        initSpeed: 'fast',
        radius:  Math.min(window.innerWidth, window.innerHeight) / 2 * 0.7,
        useHTML: true,
    });

    const handleResize = () => {
        setOptions({
            maxSpeed: 'fast',
            initSpeed: 'fast',
            radius:  Math.min(window.innerWidth, window.innerHeight) / 2 * 0.7,
            useHTML: true,
        })
    }

    useEffect(() => {
        window.addEventListener("resize", handleResize, false);
    }, []);

    const skillsList = [];
    skills.forEach((skill, index) => {
        let part = renderToString(skillItems(skill, index));
        skillsList.push(part)
    });

    return (
        <TagCloud
            options={options}
            className="flex justify-center cursor-grab select-none text-sm md:text-base"
        >
            {skillsList}
        </TagCloud>
    )
}

export default SkillCloud;